import React, { useState, useEffect, useRef } from "react";
import LayoutWrapper from "@iso/components/utility/layoutWrapper.js";
import SensorsPage from "./Sensors.styles"
import PageHeader from "@iso/components/utility/pageHeader";
import Box from "@iso/components/utility/box";
import IntlMessages from "@iso/components/utility/intlMessages";
import Highlighter from 'react-highlight-words';

import { Popconfirm, Button, Pagination, Dropdown, Menu, message } from 'antd';

import {
  PlusOutlined,
  DownOutlined,
  EditOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  PaperClipOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Table from "@iso/components/collapsing-table/table";
import Loader from "@iso/components/utility/loader";
import SensorModal from "./SensorModal"
import { sensorService,deviceSensorService } from "@iso/services";
import { traccarSensorService } from "../../../../services/traccarsensor.service";

const ManageSensor = (props) => {
  const [visibleSensorModal, setVisibleSensorModal] = useState(false);
  const [data, setData] = useState([]);
  const [sensorData, setSensorData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  
  // Server-side pagination state
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [suppliers, setSuppliers] = useState([]);
  
  useEffect(() => {
    getSensors();
  }, [currentPage, pageSize]); // Re-fetch when page or pageSize changes

  useEffect(() => {
    traccarSensorService.getSensorList().then((res) => {
      console.log(res);
    })
  })
  const showModal = () => {
    setVisibleSensorModal(true)
  }

  const cancelModal = () => {
    setVisibleSensorModal(false)
    setSensorData({})
  }

  const updateSensorsData = () => {
    // Reset to first page when updating data
    setCurrentPage(1);
    getSensors({ page: 1, pageSize });
  };

  const getSensors = (params = {}) => {
    setLoading(true);
    
    // Use current state values if not provided in params
    const requestParams = {
      search: params.search || "",
      is_show_sensors: "",
      page: params.page || currentPage,
      pageSize: params.pageSize || pageSize,
      ...params // Allow overriding with any additional params
    };

    deviceSensorService.getList(requestParams).then((res) => {
      if (res.code === "0000") {
        setData(res.devices);
        setTotalItems(res.total_item);
        setTotalPages(res.total_page);
        
        // Update current page from response if provided
        if (res.current_page) {
          setCurrentPage(parseInt(res.current_page));
        }
      }
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching sensors:", error);
      setLoading(false);
    });
  };

  const menu = (sensor) => (
    <Menu onClick={handleMenuClick.bind(this, sensor)}>
      {/* <Menu.Item key="editDetails" icon={<EditOutlined />}>
        <IntlMessages id="propertyPage.managePage.editDetails" />
      </Menu.Item> */}
      { <p style={{cursor:'pointer'}} className="deleteButton">
        <Popconfirm
          placement="bottomRight"
          title="You are about to delete individual record"
          onConfirm={() => {
            confirmDelete(sensor);
          }}
          okText="Yes"
          cancelText="No"
          className="delete-button"
        >
        <a style={{color:'rgba(0, 0, 0, 0.65)', marginLeft: '11px'}}>
          {<DeleteOutlined />}&nbsp;&nbsp;
          <IntlMessages id="propertyPage.managePage.delete" />
        </a>
        </Popconfirm>
      </p>}
    </Menu>
  );

  const confirmDelete = (device) => {
    if (device.id) {
      deviceSensorService.destroy(device.id).then((res) => {
        if (res.code === "0000") {
          message.success("Delete Sensor success!");
          
          // After successful deletion, refresh the current page
          // If current page becomes empty and we're not on page 1, go to previous page
          const newTotalItems = totalItems - 1;
          const newTotalPages = Math.ceil(newTotalItems / pageSize);
          
          if (currentPage > newTotalPages && newTotalPages > 0) {
            setCurrentPage(newTotalPages);
            getSensors({ page: newTotalPages, pageSize });
          } else {
            // Refresh current page
            getSensors({ page: currentPage, pageSize });
          }
        }
      });
    }
  };

  const handleMenuClick = (device, e) => {
    if (e.key === "editDetails") {
      setSensorData(device);
      showModal();
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // getSensors will be called automatically due to useEffect dependency
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to first page when changing page size
    // getSensors will be called automatically due to useEffect dependency
  };

  const columns = [
    {
      label: 'Supplier',
      accessor: "supplier",
      minWidth: 100,
      sortable: true,
    },
    {
      label: 'Device ID',
      accessor: "terminal_id",
      minWidth: 100,
      sortable: true,
    },
    {
      label: 'Property',
      accessor: "property_name",
      minWidth: 100,
      sortable: true,
      CustomComponent: (cell) => {
        const property = cell.row.property;

        if (property) {
          return (
            <div>{property.name}</div>
          )
        } else {
          return (
            <div>N/A</div>
          )
        }
      }
    },
    {
      label: 'Created Date',
      accessor: "created_at",
      minWidth: 100,
      sortable: true,
    },
    {
      label: "",
      accessor: "actions",
      minWidth: 100,
      sortable: false,
      noTitle: true,
      CustomComponent: (cell) => {
        let device = cell.row;
        return (
          <Dropdown overlay={menu(device)} trigger={["click"]}>
            <div
              className="property-area-dot-btn"
              style={{ cursor: "pointer" }}
            >
              <EllipsisOutlined className="dotIcon" />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <LayoutWrapper>
      <SensorsPage>
        <Box id="containerBox">
          <div className="manage-property-header">
            <div className="mp-title">
              <h2 className="manage-property-title">Sensors</h2>
            </div>
            <>
              <div className="button-group">
                <Button
                  icon={<PlusOutlined />}
                  type="primary"
                  className="btn-success"
                  onClick={showModal}
                >
                  <IntlMessages id="sensorPage.managePage.addSensor" />
                </Button>
              </div>
            </>
          </div>
          <div className="manage-table">
            {loading ? (
              <Loader />
            ) : data.length > 0 ? (
              <>
                <Table
                  columns={columns}
                  rows={data}  // Use server-paginated data directly
                  containerId="containerBox"
                  showPagination={false}
                  showSearch={false}
                  totalPages={totalPages}
                  rowSize={pageSize}
                />
                <div style={{ padding: "16px" }}>
                  <Pagination
                    current={currentPage}
                    total={totalItems}  // Use server-provided total
                    pageSize={pageSize}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    showQuickJumper
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                  />
                </div>
              </>
            ) : (
              <h1 style={{ padding: "15px 15px", color: 'gray' }}>
                <IntlMessages id="dashboardPage.noData" />
              </h1>
            )}
          </div>
        </Box>
      </SensorsPage>
      <SensorModal 
        visibleSensorModal={visibleSensorModal} 
        cancelModal={cancelModal} 
        updateSensorsData={updateSensorsData} 
        sensorData={sensorData} 
        suppliers={suppliers}
      />
    </LayoutWrapper>
  );
};

export default ManageSensor;